import { render, staticRenderFns } from "./leaderShenList.vue?vue&type=template&id=62221706&scoped=true&"
import script from "./leaderShenList.vue?vue&type=script&lang=js&"
export * from "./leaderShenList.vue?vue&type=script&lang=js&"
import style0 from "./leaderShenList.vue?vue&type=style&index=0&id=62221706&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62221706",
  null
  
)

export default component.exports